import Buttons from "views/components/Buttons.jsx";
import Calendar from "views/Calendar.jsx";
import Charts from "views/Charts.jsx";
import ExtendedForms from "views/forms/ExtendedForms.jsx";
import ExtendedTables from "views/tables/ExtendedTables.jsx";
import FullScreenMap from "views/maps/FullScreenMap.jsx";
import GoogleMaps from "views/maps/GoogleMaps.jsx";
import GridSystem from "views/components/GridSystem.jsx";
import Icons from "views/components/Icons.jsx";
import LockScreen from "views/pages/LockScreen.jsx";
import Login from "views/pages/Login.jsx";
import Notifications from "views/components/Notifications.jsx";
import Panels from "views/components/Panels.jsx";
import ReactTables from "views/tables/ReactTables.jsx";
import RegularForms from "views/forms/RegularForms.jsx";
import RegularTables from "views/tables/RegularTables.jsx";
import SweetAlert from "views/components/SweetAlert.jsx";
import Timeline from "views/pages/Timeline.jsx";
import Typography from "views/components/Typography.jsx";
import UserProfile from "views/pages/UserProfile.jsx";
import ValidationForms from "views/forms/ValidationForms.jsx";
import VectorMap from "views/maps/VectorMap.jsx";
import Widgets from "views/Widgets.jsx";
import Wizard from "views/forms/Wizard.jsx";
import WizardCustomer from "views/forms/WizardCustomer.jsx";
import ResetPwd from "./views/pages/ResetPwd";
import ChangePwd from "views/pages/ChangePwd.jsx";
import ServiceJobs from "./views/pages/ServiceJobs";




const routes = [
  {
    path: "/elektriker",
    name: "Elektriker",
    icon: "nc-icon nc-settings",
    component: ServiceJobs,    
    layout: "/admin",
    adminView: true,
    employeeView: false,
  },
  // {
  //   path: "/projects",
  //   name: "prosjektjobber",
  //   icon: "nc-icon nc-ruler-pencil",
  //   component: ProjectJobs,    
  //   layout: "/admin",
  //   invisible: true,
  //   adminView: true,
  //   employeeView: false,
  // },
  // {
  //   path: "/offers",
  //   name: "mine tilbud",
  //   icon: "nc-icon nc-book-bookmark",
  //   component: Offers,    
  //   layout: "/admin",
  //   adminView: false,
  //   employeeView: false,
  // },
  {
    collapse: true,
    name: "Customer",
    icon: "nc-icon nc-single-02",
    state: "customerCollapse",
    invisible: true,
    adminView: true,
    employeeView: false,
    views: [
      {
        path: "/registercustomer",
        name: "View Customers",
        mini: "RC",
        component: WizardCustomer,
        layout: "/admin",
        invisible: true,
        adminView: true,
        employeeView: true,
      },
      {
        path: "/registercustomer",
        name: "Register Customer",
        mini: "RC",
        component: WizardCustomer,
        layout: "/admin",
        adminView: true,
        employeeView: false,
      },
    ]
  },
  {
    collapse: true,
    name: "Pages",
    icon: "nc-icon nc-book-bookmark",
    state: "pagesCollapse",
    invisible: true,
    adminView: true,
    employeeView: false,
    views: [
      {
        path: "/timeline",
        name: "Timeline",
        mini: "T",
        component: Timeline,
        layout: "/admin",
        adminView: true,
        employeeView: false,
      },
      {
        path: "/login",
        name: "Login",
        mini: "L",
        component: Login,
        layout: "/auth",        
      },
      {
        path: "/resetpwd",
        name: "ResetPwd",
        mini: "R",
        component: ResetPwd,
        layout: "/auth",
      },
      {
        path: "/lock-screen",
        name: "LockScreen",
        mini: "LS",
        component: LockScreen,
        layout: "/auth"
      },
      {
        path: "/user-profile",
        name: "UserProfile",
        mini: "UP",
        component: UserProfile,
        layout: "/admin",
        invisible: true
      },
      {
        path: "/changePwd",
        name: "ChangePwd",
        mini: "UP",
        component: ChangePwd,
        layout: "/admin",
        invisible: true
      }
    ]
  },
  {
    collapse: true,
    name: "Components",
    icon: "nc-icon nc-layout-11",
    state: "componentsCollapse",
    invisible: true,
    adminView: true,
    employeeView: false,
    views: [
      {
        path: "/buttons",
        name: "Buttons",
        mini: "B",
        component: Buttons,
        layout: "/admin"
      },
      {
        path: "/grid-system",
        name: "Grid System",
        mini: "GS",
        component: GridSystem,
        layout: "/admin"
      },
      {
        path: "/panels",
        name: "Panels",
        mini: "P",
        component: Panels,
        layout: "/admin"
      },
      {
        path: "/sweet-alert",
        name: "Sweet Alert",
        mini: "SA",
        component: SweetAlert,
        layout: "/admin"
      },
      {
        path: "/notifications",
        name: "Notifications",
        mini: "N",
        component: Notifications,
        layout: "/admin",
        invisible: false,
        adminView: true,
      },
      {
        path: "/icons",
        name: "Icons",
        mini: "I",
        component: Icons,
        layout: "/admin"
      },
      {
        path: "/typography",
        name: "Typography",
        mini: "T",
        component: Typography,
        layout: "/admin"
      }
    ]
  },
  {
    collapse: true,
    name: "Forms",
    icon: "nc-icon nc-ruler-pencil",
    state: "formsCollapse",
    invisible: true,
    adminView: true,
    employeeView: true,
    views: [
      {
        path: "/regular-forms",
        name: "Regular Forms",
        mini: "RF",
        component: RegularForms,
        layout: "/admin",
        adminView: true,
        employeeView: true,
      },
      {
        path: "/extended-forms",
        name: "Extended Forms",
        mini: "EF",
        component: ExtendedForms,
        layout: "/admin",
        adminView: true,
        employeeView: true,
      },
      {
        path: "/validation-forms",
        name: "Validation Forms",
        mini: "VF",
        component: ValidationForms,
        layout: "/admin",
        adminView: true,
        employeeView: true,
      },
      {
        path: "/wizard",
        name: "Wizard",
        mini: "W",
        component: Wizard,
        layout: "/admin",
        adminView: true,
        employeeView: true,
      }
    ]
  },
  {
    collapse: true,
    name: "Tables",
    icon: "nc-icon nc-single-copy-04",
    state: "tablesCollapse",
    invisible: true,
    adminView: true,
    employeeView: true,
    views: [
      {
        path: "/regular-tables",
        name: "Regular Tables",
        mini: "RT",
        component: RegularTables,
        layout: "/admin",
        adminView: true,
        employeeView: true,
      },
      {
        path: "/extended-tables",
        name: "Extended Tables",
        mini: "ET",
        component: ExtendedTables,
        layout: "/admin",
        adminView: true,
        employeeView: true,
      },
      {
        path: "/react-tables",
        name: "React Tables",
        mini: "RT",
        component: ReactTables,
        layout: "/admin",
        adminView: true,
        employeeView: true,
      }
    ]
  },
  {
    collapse: true,
    name: "Maps",
    icon: "nc-icon nc-pin-3",
    state: "mapsCollapse",
    invisible: true,
    views: [
      {
        path: "/google-maps",
        name: "Google Maps",
        mini: "GM",
        component: GoogleMaps,
        layout: "/admin"
      },
      {
        path: "/full-screen-map",
        name: "Full Screen Map",
        mini: "FSM",
        component: FullScreenMap,
        layout: "/admin"
      },
      {
        path: "/vector-map",
        name: "Vector Map",
        mini: "VM",
        component: VectorMap,
        layout: "/admin"
      }
    ]
  },
  {
    path: "/widgets",
    name: "Widgets",
    icon: "nc-icon nc-box",
    component: Widgets,
    invisible: true,
    layout: "/admin",
    adminView: true,
    employeeView: false,
  },
  {
    path: "/charts",
    name: "Charts",
    icon: "nc-icon nc-chart-bar-32",
    component: Charts,
    invisible: true,
    layout: "/admin",
    adminView: true,
    employeeView: false,
  },
  {
    path: "/calendar",
    name: "Calendar",
    icon: "nc-icon nc-calendar-60",
    component: Calendar,
    invisible: true,
    layout: "/admin"
  }
];

export default routes;
